import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import LabelGenerationActions from '@Actions/configurations/labelGenerationActions';
import UserActions from '@Actions/userActions';

import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';
import { Drawer } from 'antd';
import GlobalLabelsCard from '../GlobalLabelsCard';

import LabelGenerationFrom from '../LabelGenerationFrom';
import './style.scss';

const GlobalLabelsList = ({
  user, entityName, getLabelGenerationLoading, labelGeneration, getLabelGeneration, getGlobalLabels, getGlobalLabelsLoading, globalLabels,
}) => {
  const [call, setCall] = useState(false);
  const [showFormDrawer, setShowFormDrawer] = useState(false);
  const [selectedGlobalLabel, setSelectedGlobalLabel] = useState({});

  useEffect(() => {
    if (entityName) {
      getGlobalLabels({ entityName }, () => { });
    }
  }, [entityName]);

  useEffect(() => {
    if (entityName) {
      getLabelGeneration({ orgId: user?.org_id, entityName }, () => { });
    }
  }, [entityName, call]);

  const getGlobalLabelsData = (orgLabels = [], allGlobalLabels) => {
    const selectedTemplatesForAllTenants = orgLabels?.filter((label) => label?.tenant_id === null)?.map((label) => label?.global_label_id);

    let newGlobalLabels = JSON.parse(JSON.stringify(allGlobalLabels));
    newGlobalLabels = newGlobalLabels?.map((data) => ({
      ...data,
      isAdded: selectedTemplatesForAllTenants.includes(data?.global_label_id),
    }));

    return newGlobalLabels;
  };

  return (
    <Fragment>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
        {(getLabelGenerationLoading || getGlobalLabelsLoading) ? (
          <GlobalLabelsCard loading={getLabelGenerationLoading || getGlobalLabelsLoading} />
        ) : (labelGeneration && globalLabels) && getGlobalLabelsData(labelGeneration, globalLabels)?.map((label) => (
          <GlobalLabelsCard
            key={label?.global_label_id}
            labelsData={label}
            setShowFormDrawer={setShowFormDrawer}
            setSelectedGlobalLabel={setSelectedGlobalLabel}
            callback={() => {
              setCall(!call);
            }}
          />
        ))}
      </div>
      <Drawer
        open={showFormDrawer}
        width="500px"
        mask
        onClose={() => {
          setShowFormDrawer(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '450px' }}>
            <H3Text text="Add New Template" className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowFormDrawer(false);
              }}
            />
          </div>
        </div>
        <div>
          <LabelGenerationFrom
            selectedOrgLabels={labelGeneration}
            selectedLabel={selectedGlobalLabel}
            isUpdate={false}
            callback={() => {
              setShowFormDrawer(false);
              setCall(!call);
            }}
          />
        </div>
      </Drawer>

    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, LabelGenerationReducers }) => ({
  user: UserReducers.user,
  getLabelGenerationLoading: LabelGenerationReducers.getLabelGenerationLoading,
  labelGeneration: LabelGenerationReducers.labelGeneration,
  getGlobalLabelsLoading: LabelGenerationReducers.getGlobalLabelsLoading,
  globalLabels: LabelGenerationReducers.globalLabels,
});

const mapDispatchToProps = (dispatch) => ({
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  getLabelGeneration: (payload, callback) => dispatch(LabelGenerationActions.getLabelGeneration(payload, callback)),
  getGlobalLabels: (payload, callback) => dispatch(LabelGenerationActions.getGlobalLabels(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GlobalLabelsList));
